export default {
    items: null,
    actionStatus: null,
}